import React from 'react';
import { connect } from 'react-redux';
import { IMenuState, fetchMemberStories } from 'src/store/slices/index';
import { RootState } from 'src/store';
import { Responsive } from 'src/utils/index';
import { CompanyLogos, MemberStoriesCarousel } from 'src/components/components/index';
import { LandingCompanyLogos, TreatYourselfLogos } from 'src/common-types/index';
import { Benefits } from '../benefits';
import { NotificationBar } from '../notification-bar';
import { TravelLeader } from '../travel-leader';
import { ConciergeServices } from '../concierge-services';
import { ListClickableCards } from '../list-clickable-cards';
import { TutorialVideos } from '../tutorial-videos';
import { TreatYourself } from '../../common';
import { MasterClasses } from '../master-classes';
import './style.scss';

interface IMapStateToProps {
  menuStore: IMenuState;
}

interface IMapDispatchToProps {
  getMemberStories: () => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps {}

class HomeComponent extends React.Component<IProps, null> {
  componentDidMount() {
    this.props.getMemberStories();
  }

  render(): React.ReactNode {
    const { menuStore } = this.props;

    return (
      <div className="home-wrapper">
        <Responsive>
          <TravelLeader />
        </Responsive>
        <NotificationBar />
        <Benefits />
        <ConciergeServices />
        <ListClickableCards />
        <TutorialVideos />
        <CompanyLogos logos={LandingCompanyLogos} />
        <TreatYourself
          customerServiceNumber={menuStore.items?.customerServiceNumber}
          logos={TreatYourselfLogos}
        />
        <MasterClasses />
        <MemberStoriesCarousel />
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    menuStore: state.navigationMenuStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = { getMemberStories: fetchMemberStories };

export const Home = connect(mapStateToProps, mapDispatchToProps)(HomeComponent);
